import React, { useEffect, useState, useMemo } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { Card, CardHeader, Col, Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb.js";
import Axios from "../../lib/Axios.js";

// Register the necessary Chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const GenderAnalytics = () => {
  // const [data, setData] = useState([{gender:"Male",id:1},{gender:"Female",id:2},{gender:"Others",id:3}]); // Store labels and IDs
  const [data] = useState([
    { gender: "Male", id: 1 },
    { gender: "Female", id: 2 },
    { gender: "Others", id: 3 },
  ]);
  const [counts, setCounts] = useState([]); // Store counts for each label

  const barOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Looking For Analytics",
      },
    },
  };

  useEffect(() => {
    const fetchList = async () => {
      try {
        // Fetch counts for each 'lookingForId'
        const countsPromises = data.map(async (v) => {
          const response = await Axios.post("/cms/cms-get/analytics/gender-count", {
            genderId: v.id,
          });
          return response?.data?.result?.results || 0;
        });
  
        const resolvedCounts = await Promise.all(countsPromises);
        setCounts(resolvedCounts);
      } catch (error) {
        console.error("Error fetching analytics data:", error);
      }
    };

    fetchList();
  }, [data]);

  // Memoize barData to ensure it updates dynamically
  const barData = useMemo(() => {
    return {
      labels: data.map((tag) => tag.gender), // Labels are dynamically generated
      datasets: [
        {
          label: "Number of Users",
          data: counts.length ? counts : [], // Use resolved counts
          backgroundColor: "#33A2EB",
        },
      ],
    };
  }, [data, counts]); // Dependencies for recalculating barData

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Dashboard" breadcrumbItem="Looking For Analytics" />
          <Col lg={12}>
            <Card>
              <CardHeader>
                <h4 className="card-title mb-0">Looking For Analytics</h4>
              </CardHeader>
              <div style={{ padding: "20px" }}>
                {counts.length ? (
                  <Bar data={barData} options={barOptions} />
                ) : (
                  <p>Loading chart...</p>
                )}
              </div>
            </Card>
          </Col>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default GenderAnalytics;
